module.exports = __webpack_public_path__ + "../resources/img/ic_fold_right_disabled.de1f3abc.svg";